/* Gimbel 2026-10-23: Resources (top nav row) opens on click, not hover.
   The other dropdowns keep their hover behaviour.

   Why: the Resources panel is wide and sits right above the product row,
   so a pointer passing through the top row opened it constantly.

   How Focal opens menus: <desktop-navigation> (assets/theme.js,
   DesktopNavigation) registers one delegated listener with
   addEventListener("mouseenter", handler, true) on itself, matches
   ".has-dropdown", and calls openDropdown(li) after 100ms. It closes on
   mouseleave of the li. Its click handler returns early on hover-capable
   devices, so a click on Resources today just follows the "#" href.

   What this does:
   1. A capture-phase mouseenter listener on document runs before the
      theme's (document is an ancestor of <desktop-navigation> in the
      capture path). For the Resources <li> only, it stops propagation,
      so the theme never sees that one mouseenter and nothing opens.
      mouseenter on children of the li (the link, the panel) is left
      alone; the theme ignores those anyway (event.target !== li).
   2. A click on the Resources link is intercepted: preventDefault (so the
      "#" href does not scroll to top) and the theme's own openDropdown /
      closeDropdown are called on the <desktop-navigation> instance. That
      keeps the close-on-mouseleave, the open/close CustomEvents, the
      100ms open delay and the theme-editor behaviour identical to the
      hover menus. Click again (or press Enter on the link) closes it.

   Scope: only li.header__linklist-item.resources inside
   .header-additional-menu (the top row). The four product dropdowns in
   .bottom-mega-menu and the mobile drawer are untouched. On touch
   devices the theme already opens on tap; this adds tap-to-close.

   Companion CSS: the "Resources opens on click" block at the end of
   assets/nav-overrides.css re-keys the white bridge strip and the
   chevron from :hover to aria-expanded="true".

   Loaded from snippets/js-variables.liquid (same pattern as
   ga-ship-protection.js). Rollback: remove that script tag and this
   file, and delete the CSS block. */
(function () {
  if (window.gaResourcesClickOnly) {
    return;
  }
  window.gaResourcesClickOnly = true;

  var ITEM = '.header-additional-menu li.header__linklist-item.resources.has-dropdown';
  var LINK = ITEM + ' > a.header__linklist-link';

  // 1. Block the theme's hover-open for the Resources item only.
  document.addEventListener('mouseenter', function (event) {
    var target = event.target;
    if (target && target.nodeType === 1 && target.matches(ITEM)) {
      event.stopPropagation();
    }
  }, true);

  // 2. Click toggles it, using the theme's own open/close methods.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || target.nodeType !== 1) {
      return;
    }
    var link = target.closest(LINK);
    if (!link) {
      return;
    }
    event.preventDefault();

    var item = link.parentElement;
    var nav = item.closest('desktop-navigation');
    if (!nav || typeof nav.openDropdown !== 'function' || typeof nav.closeDropdown !== 'function') {
      return; // theme.js not ready yet; swallowing the click beats jumping to the top of the page
    }
    if (link.getAttribute('aria-expanded') === 'true') {
      nav.closeDropdown(item);
    } else {
      nav.openDropdown(item);
    }
  }, true);
})();
